import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='m-8 mb-20 text-center text-purple-800/60'>
        © 2024-2025 <a href="https://funamp.jp" className='underline'>大規模鬼ごっこ事務局</a><br />

        <Link to='/info' className='underline text-sm'>利用に関する規約等</Link>

    </div>
  )
}

export default Footer